export default "__VITE_ASSET__BAor2taF__"